var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m11.973 14.5.002-3.179c0-.088.005-.175.017-.26m0 0c.112-.803.733-1.56 1.484-1.561h.001c.831 0 1.505.894 1.505 1.821l.002 1m-2.992-1.26V7.679c0-.927-.673-1.679-1.504-1.679h-.002c-.83.001-1.502.753-1.501 1.679.007 6.556.006 8.333-.002 8.331-1.378 0-2.421-2.953-4.23-2.953-1.81 0-2.113 1.073-1.39 2.023.482.633 5.62 6.92 5.62 6.92H17a4 4 0 0 0 4-4v-4.5c0-.927-.674-1.679-1.505-1.679h-.001c-.83.001-1.502.753-1.501 1.679l-.002 1m-3.008-2.179V14.5m0-2.179c0-.926.672-1.678 1.502-1.679h.001c.831 0 1.505.752 1.505 1.68V13.5m-2.636-5.64a4.95 4.95 0 1 0-9.818-.908m9.818.907-1.65-1.65m1.65 1.65 1.65-1.65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand3);
export default __webpack_public_path__ + "static/media/hand3.738246e6a31da1ea99be55ac82fda9c7.svg";
export { ForwardRef as ReactComponent };